import React from "react";

import FieldCheckbox from "components/FieldCheckbox";

interface Props {
	currentResponse?: boolean;
	setResponse: React.Dispatch<React.SetStateAction<boolean | undefined>>;

	currentNote?: string;
	setNote: React.Dispatch<React.SetStateAction<string | undefined>>;

	extraContent?: React.ReactNode;
}

const ResponseForm: React.FunctionComponent<Props> = ({
	currentResponse,
	setResponse,
	currentNote,
	setNote,
	extraContent
}) => {
	return (
		<form>
			<div className="row gtr-uniform">
				<div className="col-6 col-12-small">
					<FieldCheckbox
						id="response-decline"
						name="response-decline"
						checked={currentResponse === false}
						labelText="No"
						onChange={e =>
							setResponse(e.currentTarget.checked ? false : currentResponse)
						}
					/>
				</div>

				<div className="col-6 col-12-small">
					<FieldCheckbox
						id="response-accept"
						name="response-accept"
						checked={currentResponse === true}
						labelText="Yes"
						onChange={e =>
							setResponse(e.currentTarget.checked ? true : currentResponse)
						}
					/>
				</div>

				<div className="col-12">
					<textarea
						placeholder="Accompanying note"
						value={currentNote ? currentNote : ""}
						onChange={e => setNote(e.currentTarget.value)}
					/>
				</div>

				{extraContent}
			</div>
		</form>
	);
};

export default ResponseForm;
